module.exports = __webpack_public_path__ + "media/images/recruitment/landing/price01_sp-95c86181b9bfd34ba1b744fc0422d288.svg";